<template>
  <div class="column">
    <div class="card" style="margin-top:2px; min-height: 862px;">
      <div class="card-header">
        <div class="pec-header" style="margin: 0 auto;">
          <div class="headertext">{{ $t('Webportal.DashboardBMWMoto.FiveMustScore') }}</div>
          <performanceitem id="headkpi"
                           :overallByWave="getOverallByWave"
                           :kpi="getKpiFiveMust"
                           :isBMWMoto="true" />
          <!-- <div class="headertext" style="margin-left: 2em;">{{ $t('Webportal.DashboardBMWMoto.RetailStandardsScore') }}</div>
          <performanceitem id="headkpi"
                           :overallByWave="getOverallByWave"
                           :kpi="getKpiRetailStandards"
                           :isBMWMoto="true" /> -->
        </div>
      </div>

      <div class="card-body col-15">

        <div class="il-table">
          <div class="il-row col-15" >

            <!-- Cluster 1 Welcome and Reception -->
            <div class="il-cell col-3">
              <tableitem :overallByWave="getOverallByWave"
                         :kpi="getKpiWelcomeReception"
                         :hideNSC="true"
                         :isHeader="true"
                         :isBMWMoto="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpi2_1" :hasStar="true" :isBMWMoto="true" />
              </div>
            </div>

            <!-- Cluster 2 Vehicle Presentation -->
            <div class="il-cell col-3">

              <tableitem :overallByWave="getOverallByWave"
                         :kpi="getKpiVehiclePresentation"
                         :hideNSC="true"
                         :isHeader="true"
                         :isBMWMoto="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi5_1"
                           :hasStar="true"
                           :isBMWMoto="true" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi6"
                           :hasStar="true"
                           :isBMWMoto="true" />
              </div>

            </div>

            <!-- Cluster 3 Test Ride -->
            <div class="il-cell col-3">

              <tableitem :overallByWave="getOverallByWave"
                         :kpi="getKpiTestRide"
                         :hideNSC="true"
                         :isHeader="true"
                         :isBMWMoto="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi7"
                           :hasStar="true"
                           :hasDashBorder="true"
                           :isBMWMoto="true" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi8_1"
                           :hasStar="true"
                           :isBMWMoto="true" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi9_1"
                           :hasStar="true"
                           :isBMWMoto="true" />
              </div>
              <!-- Unterschied zw. "03. Test Drive Offer" und "06. Test Drive Offer"?
              <tableitem :overallByWave="getOverallByWave" :kpi="dashdata.KPI[16]" :hasStar="true"></tableitem>-->

            </div>

            <!-- Cluster 4 Offer -->
            <div class="il-cell col-3">

              <tableitem :overallByWave="getOverallByWave"
                         :kpi="getKpiOffer"
                         :hideNSC="true"
                         :isHeader="true"
                         :isBMWMoto="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi10"
                           :hasDashBorder="true"
                           :isBMWMoto="true" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi11_2"
                           :hasDashBorder="true"
                           :isBMWMoto="true" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi11_3"
                           :hasDashBorder="true"
                           :hasStar="true"
                           :isBMWMoto="true" />

                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi12"
                           :hasDashBorder="true"
                           :hasStar="true"
                           :isBMWMoto="true" />
              </div>

            </div>

            <!-- Cluster 5 Follow Up -->
            <div class="il-cell col-3">

              <tableitem :overallByWave="getOverallByWave"
                         :kpi="getKpiFollowUp"
                         :hideNSC="true"
                         :isHeader="true"
                         :isBMWMoto="true" />
              <titleunderline />

              <div class="dash-card-inner">

              <!-- Unterschied zw. "05. Follow-up on Offer" und "09. Follow-up on Offer"? -->
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpi14"
                           :hasStar="true"
                           :hasDashBorder="true"
                           :isBMWMoto="true" />
              </div>
            </div>

          </div>

        </div>

      </div>

    </div>
  </div>
</template>

<script>

  import performanceitem from './PerformanceItem'
  import tableitem from './TableItem.vue'
  import WideNscItem from './WideNscItem.vue'
  import titleunderline from './TitleUnderline'

  export default {
    name: 'BMWMotorradProcessExcellenceColumn',
    data: function(){
      return {
        kpi1 : {}
      }
    },

    components: {
      performanceitem,
      tableitem,
      WideNscItem,
      titleunderline
    },

    props:[
      'dashdata',
    ],

    methods:{
      getKpiByString: function (code) {
        if (this.dashdata && this.dashdata.KPI && _.size(this.dashdata.KPI) > 0)
          return _.find(this.dashdata.KPI, (x) => x.KpiCode === code)
      },
      getKpiGroupByString: function (code) {
        if (this.dashdata && this.dashdata.KPIGroup && _.size(this.dashdata.KPIGroup) > 0)
          return _.find(this.dashdata.KPIGroup, (x) => x.KpiCode === code)
      },
      getQuestionByString: function(code) {
        if (this.dashdata && this.dashdata.Question && _.size(this.dashdata.Question) > 0)
          return _.find(this.dashdata.Question, (x) => x.KpiCode === code)
      }
    },

    computed: {

      getOverallByWave: function() {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return this.dashdata.OverallByWave[0]
        return undefined
      },

      getKpiFiveMust: function () {
        return this.getKpiGroupByString('Conquest & Loyalty')
      },

      getKpiRetailStandards: function () {
        return this.getKpiGroupByString('Contractual Standards')
      },

      // Welcome Reception Column
      getKpiWelcomeReception: function() {
        return this.getKpiGroupByString('3. Welcome and reception')
      },
      getKpi2_1: function() {
        return this.getQuestionByString('0038919')
      },

      // Vehicle Presentation Column
      getKpiVehiclePresentation: function() {
        return this.getKpiGroupByString('5. Vehicle presentation')
      },
      getKpi5_1: function() {
        // Survey 594 (BMW Motorrad)
        let result = this.getQuestionByString('0049563');

        if (!result)
        {
          // Survey 1051 (BMW Used Bike): Take result of both questions "5.1" from KPI "RS 3" but metadata from question itself
          result = this.getKpiByString('RS 3 (Standard 8.3)')
          let question = this.getQuestionByString('0104233') || this.getQuestionByString('0103295');
          if (result && question)
          {
            result.QuestionText = question.QuestionText;
            result.KpiName = question.KpiName;
          }
        }

        return result
      },
      getKpi6: function() {
        return this.getQuestionByString('0026892') || this.getQuestionByString('0103296')
      },

      // Test Ride Column
      getKpiTestRide: function() {
        return this.getKpiGroupByString('6. Test Ride')
      },
      getKpi7: function() {
        return this.getQuestionByString('0038934') || this.getQuestionByString('0103297')
      },
      getKpi8_1: function() {
        return this.getQuestionByString('0038936') || this.getQuestionByString('0103298')
      },
      getKpi9_1: function() {
        return this.getQuestionByString('0038938') || this.getQuestionByString('0103299')
      },

      // Offer Column
      getKpiOffer: function() {
        return this.getKpiGroupByString('7. Offer')
      },
      getKpi10: function() {
        return this.getQuestionByString('0027444')
      },
      getKpi11_1: function() {
        return this.getQuestionByString('0026923')
      },
      getKpi11_2: function() {
        return this.getQuestionByString('0026924')
      },
      getKpi11_3: function() {
        return this.getQuestionByString('0026925')
      },
      getKpi11_4: function() {
        return this.getQuestionByString('0026911')
      },
      getKpi12: function() {
        return this.getQuestionByString('0026909')
      },

      // FollowUp Column
      getKpiFollowUp: function() {
        return this.getKpiGroupByString('9. Follow-up')
      },
      getKpi14: function() {
        return this.getQuestionByString('0026917')
      }
    }
  }

</script>

<style scoped>

  .rectindicator {
    display: inline-block;
    margin-left: 6px;

    width:16px;
    height: 16px;
    vertical-align: top;
    margin-top: 12.5px;
  }

  .headertext {
    display: inline-block;
    height: 24pt;
    text-align: center;
    color: #111111;
    position: relative;
    top: -6px;
    display: inline-block;
    font-weight: 500;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

  .headertextspace{
    width: 10px;
  }

  #headtext2 {
    height: 24pt;
    text-align: center;
    color: #111111;
    position: relative;
    top: -6px;
    display: inline-block;
    font-weight: 500;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

  .column {
    margin: 0px;
    padding: 0px;
    position: relative;
    top: 0px;
    margin-block-end: 0px;
    margin-inline-end: 0px;
  }

  .subitem{
    margin-inline-start: 6px;
    margin-inline-end: 6px;
    margin-block-start: 2px;
    margin-block-end: 2px;
  }

  .subitemlostleadsstyle {
    margin-inline-start: 36px;
    margin-inline-end: 6px;
    margin-block-start: 2px;
    margin-block-end: 2px;
  }

  .col-3{
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
    border-width: 0px;
  }

  .card-header:first-child {
    border-radius: 0px;
    margin: 0px;
    padding: 0px;
  }

  .card-header {
    background: #d9d9d9;
    border-width: 0px;
    width: 100%;
    height: 40px;
  }

  .pec-header {
    display: table;
    margin: 0 auto;
  }

  .card-body {
    padding: 0px;
    margin: 0px;
  }

  .card {
    border: solid #bfbfbf;
    border-width: 2px;
    border-radius: 0rem;
    margin: 0px;
    padding: 0px;
    padding-left: 44px;
    height:787px;
    vertical-align: top;
  }

  .il-table{
    font-size: 9pt;
    font-size-adjust: inherit;
    height: fit-content;
    width: 100%;
    display: table;
  }

  .il-row {
    width: 100%;
    float: left;
  }

  #dimmedout {
    opacity: 0.5;
    filter: alpha(opacity=50);
  }

  .il-cell {
    float: left;
    width: 20%;
    text-overflow: ellipsis;
    display: table-cell;
  }

  .pec-card{
    float: left;
  }

  .card {
    margin-top: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    padding: 0px;
  }

  h3{
    height: 36pt;
    line-height: 28pt;
    text-align: center;
    float: left;
    top: 0px;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

</style>
